import { Box, Typography, Paper, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useSelector } from "react-redux";
import { RootState } from "../../configureStore";
import { useTheme } from "../../ThemeContext";
import { ConfigDetail } from "../../interface/configs";
import ConfigList from "../organisms/ConfigList";
import ConfigEditor from "../organisms/ConfigEditor";

const ConfigManagement = () => {
    const navigate = useNavigate();
    const { mode, toggleColorMode } = useTheme();
    const selectedConfig = useSelector<RootState, ConfigDetail | null>(({ configs }) => configs.selectedConfig);

    return (
        <Box sx={{ p: 2, minHeight: "100vh", position: "relative" }}>
            {/* Header Row */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <IconButton
                        onClick={() => navigate("/returns")}
                        color="primary"
                        size="small"
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography
                        variant="h5"
                        component="h1"
                        sx={{ fontWeight: 600 }}
                    >
                        Config Management
                    </Typography>
                </Box>
                <IconButton
                    onClick={toggleColorMode}
                    color="inherit"
                    size="small"
                >
                    {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
                </IconButton>
            </Box>

            {/* Main Content - Split View */}
            <Box sx={{ display: "flex", gap: 2, height: "calc(100vh - 80px)", minHeight: 600 }}>
                {/* Left Panel - Config List */}
                <Paper sx={{ width: 220, flexShrink: 0, overflow: "hidden" }}>
                    <ConfigList selectedConfigName={selectedConfig?.name || null} />
                </Paper>

                {/* Right Panel - Editor */}
                <Paper sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    <ConfigEditor />
                </Paper>
            </Box>
        </Box>
    );
};

export default ConfigManagement;
